// extracted by mini-css-extract-plugin
export default {"commonButton":"Buttons_commonButton__T2VKS","primaryButton":"Buttons_primaryButton__KxqnB","dangerButton":"Buttons_dangerButton__Dtj0X"};